export const SEGMENTED_SELECT_MAX_TOGGLE_OPTIONS = 3;
